import { render } from "./Tool.vue?vue&type=template&id=ce668bec&scoped=true&ts=true&lang=pug"
import script from "./Tool.vue?vue&type=script&lang=ts"
export * from "./Tool.vue?vue&type=script&lang=ts"

import "./Tool.vue?vue&type=style&index=0&id=ce668bec&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce668bec"]])

export default __exports__